$(document).ready(function(){
	$('.cca-mega-menu').each(function(){
		var $el = $(this);
		var $tabs = $el.find('.mm-tab');

		$tabs.on('click','.mm-tab-inner', function(){
			var $tab = $(this).closest('.mm-tab');
			if($tab.hasClass('active')){
				$tab.removeClass('active');
				return;
			}
			
			var $tabContent = $tab.find('.mm-tab-content');
			$tabs.not($tab).removeClass('active');
			
			$tab.addClass('active');
			$tabContent
				.css('margin-left', '0')
				.width('0')
				.width($(document).width())
				.css('margin-left', '-' + $tabContent.offset().left + 'px');

			//initialize un-inizialized carousel if any exist insde tab content
			$.each($tabContent.find('.mm-card-carousel[cca-is-carousel]'), function (i, el) { 
				var $slider = $(el);
				if(!$slider.hasClass('cca--initialized')){
					$slider.slick({
						arrows: false,
						dots: true,
						infinite: false
					}).addClass('cca--initialized');

					//clamp text
					setTimeout(function(){
						$.each($slider.find('.article-box, .resources-box, .card-v2'), function (i, el) { 
							window.clampText($(el));
						});
					}, 300);
				}

				$slider.slick('setPosition');
			});
		});

		$(window).on('resize', function(){
			var $currentOpenTabContent = $tabs.filter('.active').find('.mm-tab-content');

			if(!$currentOpenTabContent.length) return;

			$currentOpenTabContent
				.css('margin-left', '0')
				.width('0')
				.width($(document).width())
				.css('margin-left', '-' + $currentOpenTabContent.offset().left + 'px');

				$.each($currentOpenTabContent.find('.mm-card-carousel[cca-is-carousel]'), function (i, el) {
					var $slider = $(el); 
					$.each($slider.find('.article-box, .resources-box, .card-v2'), function (i, el) { 
						window.clampText($(el));
					});
					$slider.slick('setPosition');
				});
		});

		//event for go to anchor on tab titles
		$el.on('click', 'a[data-link-type="anchor"]', function(){
			var $this = $(this);
			var $elem = $('#' + $this.attr('href').replace('#', ''));
			if($elem.length){
				$tabs.removeClass('active');
				$("html, body").animate({scrollTop: $elem.offset().top - 50}, 350)
			};
			
		});

		$el.on('click', '.mm-col-content > ul > li > a', function(e){
			e.preventDefault();

			var $this = $(this);
			var samePageAnchor = window.getSamePageAnchor($this.attr('href'));
			
			if(samePageAnchor){
				var $elem = $('#' + samePageAnchor.replace('#', ''));
				if($elem.length){
					$tabs.removeClass('active');
					$("html, body").animate({scrollTop: $elem.offset().top - 50}, 350);
				};	
			}else{
				window.location.href = $this.attr('href');
			}
		});

		$(document).on("click", function (ev) {
			if ($(ev.target).closest(".cca-mega-menu").length === 0) {
				$tabs.removeClass('active');
			}
		});
	});
});